<div
  class="flash-card"
  [class.flipped]="isFlipped"
  [ngClass]="{
    'flash-card-light': theme === 'light',
    'flash-card-dark': theme === 'dark',
    'flash-card-paper': theme === 'paper',
  }"
  (click)="onCardClick()"
>
  <!-- Front side for Word -->
  <div class="card-face card-front" *ngIf="isWord()">
    <div class="card-content">
      <div class="word-language" *ngIf="wordData?.language">
        <ddc-country-flag [ddc_lng]="wordData.language"></ddc-country-flag>
      </div>
      <div class="word-article" *ngIf="wordData?.article">
        {{ wordData.article }}
      </div>
      <div class="word-main">
        {{ wordData?.word || 'No word available' }}
      </div>
      <div class="word-pos" *ngIf="wordData?.pos">
        <em>{{ wordData.pos }}</em>
      </div>
    </div>
    <div class="flip-hint">
      <mat-icon>touch_app</mat-icon>
      <span>Tap to reveal</span>
    </div>
  </div>

  <!-- Front side for Pair -->
  <div class="card-face card-front" *ngIf="isPair()">
    <div class="card-content">
      <div class="word-language" *ngIf="pairData?.word_1?.language">
        <ddc-country-flag [ddc_lng]="pairData.word_1.language"></ddc-country-flag>
      </div>
      <div class="word-article" *ngIf="pairData?.word_1?.article">
        {{ pairData.word_1.article }}
      </div>
      <div class="word-main">
        {{ pairData?.word_1?.word || 'No word available' }}
      </div>
      <div class="word-pos" *ngIf="pairData?.word_1?.pos">
        <em>{{ pairData.word_1.pos }}</em>
      </div>
    </div>
    <div class="flip-hint">
      <mat-icon>touch_app</mat-icon>
      <span>Tap to reveal {{ getLanguageName(pairData?.word_2?.language) || 'pair' }}</span>
    </div>
  </div>

  <!-- Back side for Word (Definition/Example) -->
  <div class="card-face card-back" *ngIf="isWord()">
    <div class="card-content">
      <div class="word-header">
        <div style="display: flex; align-items: center; gap: 15px">
          <span class="word-small">{{ wordData?.word || 'Word' }}</span>
          <ddc-country-flag [ddc_lng]="wordData?.language"></ddc-country-flag>
        </div>
      </div>

      <div class="definition-section" *ngIf="hasDefinition()">
        <div class="section-label">
          <mat-icon>book</mat-icon>
          <span>Definition</span>
        </div>
        <div class="definition-content">
          {{ wordData?.definition }}
        </div>
      </div>

      <div class="example-section" *ngIf="hasExample()">
        <div class="section-label">
          <mat-icon>format_quote</mat-icon>
          <span>Example</span>
        </div>
        <div class="example-content">
          {{ wordData?.example }}
        </div>
      </div>

      <div class="no-content" *ngIf="!hasDefinition() && !hasExample()">
        <p>No definition or example available for this word.</p>
      </div>
    </div>
    <div class="flip-hint">
      <mat-icon>touch_app</mat-icon>
      <span>Tap to flip back</span>
    </div>
  </div>

  <!-- Back side for Pair (Second word) -->
  <div class="card-face card-back" *ngIf="isPair()">
    <div class="card-content pair-content">
      <div class="word-language" *ngIf="pairData?.word_2?.language">
        <ddc-country-flag [ddc_lng]="pairData.word_2.language"></ddc-country-flag>
      </div>
      <div class="word-article" *ngIf="pairData?.word_2?.article">
        {{ pairData.word_2.article }}
      </div>
      <div class="word-main">
        {{ pairData?.word_2?.word || 'No word available' }}
      </div>
      <div class="word-pos" *ngIf="pairData?.word_2?.pos">
        <em>{{ pairData.word_2.pos }}</em>
      </div>
    </div>
    <div class="flip-hint">
      <mat-icon>touch_app</mat-icon>
      <span>Tap to reveal {{ getLanguageName(pairData?.word_1?.language) || 'pair' }}</span>
    </div>
  </div>
</div>
